import React from "react";
import { Box, Typography } from "@mui/material";
import { Button, FileField, FileInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { SpecialistStatuses } from "utils/constants";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const GiveAttestationDialog = ({ specialistId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const file = data?.file?.rawFile;
    if (!file) {
      notify("Моля, изберете файл", { type: "warning" });
      return;
    }
    const payload = {
      File: { rawFile: file },
      TargetStatusId: SpecialistStatuses.EligibleForGraduation,
    };
    await dataProvider.customRequest(
      specialistRequests.changeSpecialistStatus(specialistId),
      payload,
      "PATCH",
      undefined,
      true,
    );
    notify("Успешно дадена атестация за специализант", { type: "success" });
    refresh();
  };
  return (
    <FormModal
      titleContent={"Даване на атестация на специализант"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Дай атестация"
          variant="contained"
          startIcon={<TaskAltIcon />}
        />
      }
    >
      <FileInput
        source="file"
        label="Документ"
        placeholder={
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
            <UploadFileIcon color="primary" />
            <Typography>Добавете файл</Typography>
          </Box>
        }
      >
        <FileField
          source="src"
          title="title"
        />
      </FileInput>
    </FormModal>
  );
};

export default GiveAttestationDialog;
